import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, isRef as _isRef, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53420180"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed w-full top-0 left-0 z-50 select-none" }
const _hoisted_2 = {
  id: "navbar",
  class: "h-20 flex items-center justify-between bg-black xl:px-10 px-4"
}
const _hoisted_3 = { class: "nav-icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white font-bold text-3xl cursor-pointer" }, "Unikume", -1))
const _hoisted_5 = {
  key: 0,
  class: "nav-list flex items-center gap-x-4"
}
const _hoisted_6 = { class: "bg-black rounded-md p-2 text-center w-40" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "z-[60] fixed top-0 right-0 overflow-auto h-screen bg-black w-64 hide-scrollbar"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-20 text-center font-bold text-xl text-gray-200 flex items-center justify-center" }, " Menu ", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

import { createVNode, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined, MenuOutlined } from '@ant-design/icons-vue';
import RouterLink from '@/components/shared/RouterLink.vue';
import { signout } from '@/repository/authen';
import { clearToken, getToken } from '@/util/localStorage';

interface Router {
	name: string;
	text: string;
	subRouter?: Router[];
	hasBeforeNavigate?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const navigationItems = ref<Router[]>([
	{
		name: 'Home',
		text: 'Home'
	},
	{
		name: 'adult',
		text: 'Hobby',
		subRouter: [
			{
				name: 'Anime',
				text: 'Anime'
			},
			{
				name: 'Manga',
				text: 'Manga'
			},
			{
				name: 'Novel',
				text: 'Novel'
			},
			{
				name: 'VisualNovel',
				text: 'VisualNovel'
			}
		]
	},
	{
		name: 'adult',
		text: 'Adult Content',
		subRouter: [
			{
				name: 'Illustration',
				text: 'Illustration'
			},
			{
				name: 'Hitomi',
				text: 'Hitomi'
			},
			{
				name: 'Doujin',
				text: 'Doujin'
			},
			{
				name: 'Manhwa',
				text: 'Manhwa'
			},
			{
				name: 'Hentai',
				text: 'Hentai'
			},
			{
				name: 'JAV',
				text: 'JAV'
			},
			{
				name: 'Onlyfans',
				text: 'Onlyfans'
			}
		]
	},
	{
		name: 'Config',
		text: 'Config'
	},
	{
		name: 'Signin',
		text: 'Signin | Signout',
		hasBeforeNavigate: true
	}
]);

watch(route, () => {
	navigationItems.value = navigationItems.value.map((item) => {
		if (item.name === 'Signin') {
			item.text = getToken() ? 'Signout' : 'Signin';
		}
		return item;
	});
});

let isExpanded = ref<boolean>(false);

let width = ref(window.innerWidth);
window.addEventListener('resize', () => {
	width.value = document.documentElement.clientWidth;
});

async function beforeNavigate(name: string, text: string, hasBeforeNavigate?: boolean) {
	if (!hasBeforeNavigate || route.name === name) {
		isExpanded.value = false;
		return;
	}
	if (text === 'Signout') {
		Modal.confirm({
			title: 'Signout',
			icon: createVNode(ExclamationCircleOutlined),
			content: 'Do you want to logout?',
			okText: 'Yes',
			cancelText: 'No',
			async onOk() {
				await signout();
				clearToken();
				isExpanded.value = false;
				await router.push({ name });
				await store.dispatch('alert', { type: 'success', message: 'logout successfully!' });
			}
		});
		return;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RouterLink, { to: { name: 'Home' } }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      (_unref(width) >= 640)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigationItems.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (item.subRouter?.length)
                  ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                      overlay: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subRouter, (subItem, subIndex) => {
                            return (_openBlock(), _createBlock(RouterLink, {
                              key: subIndex,
                              to: { name: subItem.name },
                              prevent: subItem.hasBeforeNavigate
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (beforeNavigate(subItem.name, subItem.text, subItem.hasBeforeNavigate)),
                                  class: _normalizeClass(
											((_unref(route).name?.toString() || '').includes(subItem.name) ? 'active' : '') +
											' my-2 nav-item relative p-4 ease-in duration-200 rounded-lg cursor-pointer text-white [&.active]:bg-gray-900 hover:bg-gray-800'
										)
                                }, _toDisplayString(subItem.name), 11, _hoisted_7)
                              ]),
                              _: 2
                            }, 1032, ["to", "prevent"]))
                          }), 128))
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          class: _normalizeClass(
								(item.subRouter.findIndex((i) => _unref(route).name?.toString().includes(i.name)) !== -1
									? 'active'
									: '') +
								' ant-dropdown-link nav-item relative p-4 ease-in duration-200 rounded-lg cursor-pointer text-white [&.active]:bg-gray-900 hover:bg-gray-800'
							),
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                        }, _toDisplayString(item.text), 3)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(RouterLink, {
                      key: 1,
                      to: { name: item.name },
                      prevent: item.hasBeforeNavigate
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(
								(_unref(route).name?.toString().length && item.name.includes(_unref(route).name.toString())
									? 'active'
									: '') +
								' nav-item relative p-4 ease-in duration-200 rounded-lg cursor-pointer text-white [&.active]:bg-gray-900 hover:bg-gray-800'
							),
                          onClick: ($event: any) => (beforeNavigate(item.name, item.text, item.hasBeforeNavigate))
                        }, _toDisplayString(item.text), 11, _hoisted_8)
                      ]),
                      _: 2
                    }, 1032, ["to", "prevent"]))
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_unref(MenuOutlined), {
              class: "text-white font-bold text-xl cursor-pointer",
              onClick: _cache[1] || (_cache[1] = () => (_isRef(isExpanded) //@ts-ignore
 ? isExpanded.value = !_unref(isExpanded) : isExpanded = !_unref(isExpanded)))
            }),
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "ease-in duration-200",
              "enter-from-class": "!opacity-0",
              "enter-to-class": "!opacity-50",
              leaveActiveClass: "ease-in duration-200",
              leaveFromClass: "opacity-50",
              leaveToClass: "opacity-0",
              appear: ""
            }, {
              default: _withCtx(() => [
                (_unref(isExpanded))
                  ? (_openBlock(), _createElementBlock("article", {
                      key: 0,
                      class: "top-0 right-0 bg-black z-50 fixed w-screen h-screen opacity-50",
                      onClick: _cache[2] || (_cache[2] = () => (_isRef(isExpanded) //@ts-ignore
 ? isExpanded.value = false : isExpanded = false))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "ease-in duration-200",
              "enter-from-class": "translate-x-[16rem]",
              "enter-to-class": "translate-x-0",
              "leave-active-class": "ease-in duration-200",
              "leave-from-class": "translate-x-0",
              "leave-to-class": "translate-x-[16rem]",
              appear: ""
            }, {
              default: _withCtx(() => [
                (_unref(isExpanded))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigationItems.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "text-start"
                        }, [
                          (item.subRouter?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_a_collapse, {
                                  bordered: false,
                                  expandIconPosition: "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_collapse_panel, {
                                      header: item.text
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subRouter, (subItem, subIndex) => {
                                          return (_openBlock(), _createBlock(RouterLink, {
                                            key: subIndex,
                                            to: { name: subItem.name },
                                            prevent: subItem.hasBeforeNavigate
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(
													((_unref(route).name?.toString() || '').includes(subItem.name) ? 'active' : '') +
													' my-2 nav-item relative p-4 pl-10 mx-4 ease-in duration-200 rounded-lg cursor-pointer text-white [&.active]:bg-gray-900 hover:bg-gray-800'
												),
                                                onClick: ($event: any) => (
													beforeNavigate(subItem.name, subItem.text, subItem.hasBeforeNavigate)
												)
                                              }, _toDisplayString(subItem.name), 11, _hoisted_13)
                                            ]),
                                            _: 2
                                          }, 1032, ["to", "prevent"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["header"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : (_openBlock(), _createBlock(RouterLink, {
                                key: 1,
                                to: { name: item.name },
                                prevent: item.hasBeforeNavigate
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(
										(_unref(route).name?.toString().length && item.name.includes(_unref(route).name.toString())
											? 'active'
											: '') +
										' nav-item relative p-4 ease-in duration-200 rounded-lg cursor-pointer text-white [&.active]:bg-gray-900 hover:bg-gray-800 pl-10'
									),
                                    onClick: ($event: any) => (beforeNavigate(item.name, item.text, item.hasBeforeNavigate))
                                  }, _toDisplayString(item.text), 11, _hoisted_14)
                                ]),
                                _: 2
                              }, 1032, ["to", "prevent"]))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}
}

})